var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1761",
    "data-name": "Group 1761",
    transform: "translate(-5676 -17852)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(5676 17852)",
    fill: "#12819c",
    opacity: 0.695
  }), /*#__PURE__*/React.createElement("g", {
    id: "photo-camera",
    transform: "translate(5684.528 17862.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1841",
    "data-name": "Group 1841",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1840",
    "data-name": "Group 1840",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4732",
    "data-name": "Path 4732",
    d: "M13.158,49.183H11.6l-.861-1.3a1.789,1.789,0,0,0-1.478-.78H5.685a1.789,1.789,0,0,0-1.478.78l-.861,1.3H1.787A1.782,1.782,0,0,0,0,50.97v6.3A1.782,1.782,0,0,0,1.787,59.06H13.158a1.782,1.782,0,0,0,1.787-1.787v-6.3A1.782,1.782,0,0,0,13.158,49.183ZM7.472,57.6A4.02,4.02,0,1,1,11.5,53.585,4.028,4.028,0,0,1,7.472,57.6Zm5.458-5.9h-.715a.528.528,0,0,1,0-1.056h.65a.527.527,0,0,1,.552.5A.514.514,0,0,1,12.93,51.7Z",
    transform: "translate(0 -47.104)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1843",
    "data-name": "Group 1843",
    transform: "translate(5.231 4.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1842",
    "data-name": "Group 1842",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4733",
    "data-name": "Path 4733",
    d: "M167.106,180.736a2.234,2.234,0,1,0,2.242,2.225A2.246,2.246,0,0,0,167.106,180.736Z",
    transform: "translate(-164.864 -180.736)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.64fb3603467d0bda1a0dd0b4d6d8a907.svg";
export { ForwardRef as ReactComponent };